import { render, staticRenderFns } from "./HighlightTypeSelect.vue?vue&type=template&id=161d0c4e"
import script from "./HighlightTypeSelect.vue?vue&type=script&lang=js"
export * from "./HighlightTypeSelect.vue?vue&type=script&lang=js"
import style0 from "./HighlightTypeSelect.vue?vue&type=style&index=0&id=161d0c4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports